import { useState, FormEvent } from 'react';
import BrandMark from './BrandMark';
import { signInWithGoogle, signInWithEmail } from '../lib/firebase';

export default function SignInGate() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  const handleGoogle = async () => {
    setError(null);
    setPending(true);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setPending(false);
    }
  };

  const handleEmail = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;
    setError(null);
    setPending(true);
    try {
      await signInWithEmail(email, password);
    } catch {
      setError('Invalid email or password');
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="relative flex min-h-dvh items-center justify-center px-4">
      {/* a single warm glow behind the card so the page isn't a black void */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/3 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-500/10 blur-[120px]"
      />
      <div className="relative w-full max-w-sm space-y-4">
        <div className="mb-6 flex flex-col items-center gap-3 text-center">
          <BrandMark className="h-12 w-12 shadow-[0_4px_20px_-4px_rgba(239,98,37,0.6)]" />
          <div>
            <h1 className="text-xl font-semibold tracking-[-0.01em] text-neutral-50">Outclose</h1>
            <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-neutral-500">
              Growth Command Center
            </p>
          </div>
        </div>
        <p className="text-center text-sm text-neutral-500">
          Sign in with your Outclose admin account.
        </p>

        <button
          className="btn btn-block bg-primary-500 hover:bg-primary-600 text-neutral-950 border-none"
          onClick={handleGoogle}
          disabled={pending}
        >
          Continue with Google
        </button>

        <div className="divider text-neutral-400 text-xs">or</div>

        <form onSubmit={handleEmail} className="space-y-3">
          <input
            type="email"
            className="input input-bordered w-full"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <input
            type="password"
            className="input input-bordered w-full"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button
            type="submit"
            className="btn btn-block btn-ghost border border-neutral-700"
            disabled={pending}
          >
            Sign in with email
          </button>
        </form>

        {error && <div className="alert alert-error text-sm">{error}</div>}
      </div>
    </div>
  );
}
